import React from "react";
import { getActionCategoryMeta } from "../constants/actionCategories.js";

/** Simple domain icons for open-action cards (inline SVG). */
export function ActionCategoryIcon({ category, className = "" }) {
  const meta = getActionCategoryMeta(category);
  const key = meta.key;

  return (
    <span
      className={`action-category-icon action-category-icon--${key}${className ? ` ${className}` : ""}`}
      aria-hidden="true"
      title={meta.label}
    >
      {key === "health" ? (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M12 21s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 5.6-7 10-7 10z" />
        </svg>
      ) : null}
      {key === "wealth" ? (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8">
          <circle cx="12" cy="12" r="8" />
          <path d="M12 7v10M9.5 9.5c.6-1 1.6-1.5 2.5-1.5 1.4 0 2.5.8 2.5 2s-1.1 2-2.5 2h-1c-1.4 0-2.5.8-2.5 2s1.1 2 2.5 2c.9 0 1.9-.5 2.5-1.5" />
        </svg>
      ) : null}
      {key === "job" ? (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8">
          <rect x="3" y="8" width="18" height="12" rx="2" />
          <path d="M8 8V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 13h18" />
        </svg>
      ) : null}
      {key === "social" ? (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8">
          <circle cx="9" cy="9" r="3" />
          <circle cx="16.5" cy="8" r="2.5" />
          <path d="M3.5 19c1.2-3 3.5-4.5 5.5-4.5S13 16 14 19M13.5 18.5c.7-2 2.2-3.2 3.5-3.2 1.5 0 2.8.9 3.5 2.7" strokeLinecap="round" />
        </svg>
      ) : null}
      {key === "personal_development" ? (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M12 3v18M12 3c3 2 6 2.5 9 2v12c-3-.5-6-1-9-3M12 3C9 5 6 5.5 3 5v12c3-.5 6-1 9-3" strokeLinejoin="round" />
        </svg>
      ) : null}
      {key === "relationship" ? (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M8.5 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM15.5 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
          <path d="M4.5 19c.8-3 2.8-4.5 4-4.5s3.2 1.2 4 3.2c.8-2 2.5-3.2 4-3.2s3.2 1.5 4 4.5" strokeLinecap="round" />
        </svg>
      ) : null}
    </span>
  );
}

export default ActionCategoryIcon;
